import { render, staticRenderFns } from "./CartItemCount.vue?vue&type=template&id=6b89112a"
import script from "./CartItemCount.vue?vue&type=script&lang=js"
export * from "./CartItemCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports